import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, HelixPalette, HelixStyles, IQuestion } from '@ideagen/helix-react-core';
import Markdown from 'react-markdown';
export const AgentQuestion = ({ dataId, content, awaitingResponse = false }) => {
    return (
    //Animated gradient border when awaiting response
    _jsxs(Box, { className: 'agent-question', "data-id": `${dataId}-agent-question`, sx: Object.assign(Object.assign({ position: 'relative', margin: '8px 0', display: 'flex', gap: '8px', padding: '0 8px', '--borderWidth': '2px', borderRadius: '6px', background: HelixPalette.white, '&::after': {
                content: '""',
                position: 'absolute',
                top: 'calc(-1 * var(--borderWidth))',
                left: 'calc(-1 * var(--borderWidth))',
                height: 'calc(100% + var(--borderWidth) * 2)',
                width: 'calc(100% + var(--borderWidth) * 2)',
                background: awaitingResponse ? `linear-gradient(60deg, ${HelixPalette.teal05}, ${HelixPalette.teal60})` : HelixPalette.neutral30,
                borderRadius: '8px',
                zIndex: -1,
                animation: awaitingResponse ? 'animatedgradient 2s ease alternate infinite' : 'none',
                backgroundSize: '300% 300%',
            }, '@keyframes animatedgradient': {
                '0%': {
                    backgroundPosition: '0% 50%',
                },
                '50%': {
                    backgroundPosition: '100% 50%',
                },
                '100%': {
                    backgroundPosition: '0% 50%',
                }
            } }, HelixStyles.style_06), { color: HelixPalette.neutral100 }), children: [_jsx(IQuestion, { size: 20, color: awaitingResponse ? HelixPalette.teal30 : HelixPalette.neutral30, style: { marginTop: '8px' } }), _jsx(Box, { children: _jsx(Markdown, { children: content }) })] }));
};
export default AgentQuestion;
